import { Component, Input, OnInit } from '@angular/core';
import { Util } from 'services/util';

@Component({
    selector: 'data-graph',
    styleUrls: ['./graph.scss'],
    templateUrl: './graph.html',
    standalone: false
})
export class DataGraphComponent implements OnInit {
    @Input() public dataUsage: number; // in MB

    public leftBarStyle: object;
    public leftProgressStyle: object;

    public rightBarStyle: object;
    public rightProgressStyle: object;

    public lowPoint: number;
    public midPoint: number;
    public highPoint: number;

    public ngOnInit(): void {
        // high point should be minimum 1 in any case
        this.highPoint = parseFloat(Util.mbToGb(this.dataUsage, true)) || 1;
        this.dataUsage = parseFloat(Util.mbToGb(this.dataUsage, false));
        this.lowPoint = 0;

        if (this.dataUsage >= 0 && this.dataUsage <= 1) {
            this.midPoint = this.highPoint;
            this.leftBarStyle = { width: '100%' };
            this.leftProgressStyle = { width: `${this.dataUsage * 100 }%` };
            this.rightBarStyle = { display: 'none' };
        } else if (this.dataUsage > 1) {
            this.midPoint = this.highPoint - 1;
            const leftBarWidth: number = this.midPoint * (100 / this.highPoint);
            this.leftBarStyle = { width: `${ leftBarWidth }%` };
            this.leftProgressStyle = { width: '100%' };
            this.rightBarStyle = { width: `${ 100 - leftBarWidth }%` };
            this.rightProgressStyle = { width: `${ (this.dataUsage - this.midPoint) * 100}%` };
        }
    }

}
